document.addEventListener('DOMContentLoaded', function () {
    var answers = document.querySelectorAll('.faq__answer');
    answers.forEach(function (el, i) {
      el.classList.add('faq__answer--tint-' + ((i % 5) + 1));
    });
  });
